import React, { useMemo } from 'react';
import { LodingSquareTabbar } from '../../molecules';
import { MetricCard, SpinnerDotted } from '../../atoms';
import { CommentSection, RatingCard, Bargraph } from '../../organisms';
import { healthCheckMale, selfspouse, sirange, WalletIcon } from '../../../../assets/images';
import { commaingNumber } from '../../../../utils';
import { UserAlert } from '../../atoms/alerts';
import { UtilizationSankyChart } from '../../../tailwind/organisms';
import WalletUtilizationCommon from './WalletUtilizationCommon';

const Vaccination = ({ loading, metricObj, ratingObj, futureAppObj, utilizationObj, sqaureTabHandler, selectedContractObj, walletUtilizationObj, benefitName}) => {
  const { ratingsPercent, totalratings, averagerating, commentSectionData } = ratingObj;
  const { dependent_dose_1, dependent_dose_2, dose_1, dose_2, total_dependent, total_vaccination, dose_3, dependent_dose_3 } = futureAppObj;
  const { barlabels, bardata, barBgColors, xAxesLabel } = utilizationObj;
  const { active_dose1, active_dose2, active_dose3, inactive_dose1, inactive_dose2, inactive_dose3, active_dependent_dose1,
          active_dependent_dose2, active_dependent_dose3, inactive_dependent_dose1, inactive_dependent_dose2, inactive_dependent_dose3,
          active_customers_count, unique_users, repeat_users }  = metricObj
  const { totalWalletAmount, walletEnable } = walletUtilizationObj;
 
  const sankyChartData = useMemo(() => {
    const employeeActiveVaccinationCount =  active_dose1 + active_dose2 + active_dose3 + active_dependent_dose1 + active_dependent_dose2 + active_dependent_dose3
    const employeeInactiveVaccinationCount = inactive_dose1 + inactive_dose2 + inactive_dose3 + inactive_dependent_dose1 + inactive_dependent_dose2 + inactive_dependent_dose3
    const activeEmployee = active_dose1 + active_dose2 + active_dose3
    const inactiveEmployee = inactive_dose1 + inactive_dose2 + inactive_dose3
    const activeDependent =  active_dependent_dose1 + active_dependent_dose2 + active_dependent_dose3
    const inactiveDependent = inactive_dependent_dose1 + inactive_dependent_dose2 + inactive_dependent_dose3

    const point1 = `Total vaccination (${metricObj.total_vaccination || 0})`

    const point2 = `Active employees (${employeeActiveVaccinationCount  || 0})`
    const point3 = `Inactive employees (${employeeInactiveVaccinationCount || 0})`


    const point4 = `For themselves (${activeEmployee || 0})`
    const point5 = `For dependents (${activeDependent || 0})`

    const point6 = `For themselves (${inactiveEmployee || 0}) `
    const point7 = `For dependents (${inactiveDependent || 0}) `

    const data = {
      nodes: [{ id: point1 }, { id: point2 }, { id: point3 }, { id: point4 }, { id: point5 }, { id: point6 }, { id: point7 },
            ],
      links: [
        {
          source: point1,
          target: point2,
          value: 50,
        },
        {
          source: point1,
          target: point3,
          value: 30,
        },
        {
          source: point2,
          target: point4,
          value: 25,
        },
        {
          source: point2,
          target: point5,
          value: 25,
        },
        {
          source: point3,
          target: point6,
          value: 15,
        },
        {
          source: point3,
          target: point7,
          value: 15,
        }
      ],
    }

    const colors = ['#0951E1', '#00A04F', '#C54B4F', '#1FBDC0', '#5163BA', '#4D6189', '#8895AF']
    return { data, colors }
  }, [metricObj.total_vaccination])


  return (
    <div>
      <p className='text-gray-700 text-base font-semibold mt-8 mb-3 leading-none'>Sponsored vaccination</p>
      { !loading ?
        <>
          <div className='border bg-white border-gray-200 rounded-md px-6 py-4 flex items-center'>
            <span className='font-semibold text-3xl text-gray-900'>{metricObj.total_vaccination}</span>
            <span className='ml-2 text-normal text-gray-600 font-semibold'>Total Vaccination</span>
          </div>
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }
          <p className='text-gray-700 text-base font-semibold mt-4 mb-3 leading-none'>COVID Vaccination for employees</p>
          <div className='flex flex-row justify-between'>
            { walletEnable && (totalWalletAmount > 0) && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={WalletIcon}
              titleClasses='font-semibold text-gray-800'
              title='Total amount added'
              subTitle='Total amount added for employee and dependent wallet utilization'
              metricClasses='flex mt-0 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>₹{commaingNumber(totalWalletAmount)}</span>}
              classes='w-1/2 inline-block mr-5'
            />)}
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Utlization of Dose 1'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(active_dose1 + inactive_dose1)}</span>}
              classes='w-1/3 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Utlization of Dose 2'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(active_dose2 + inactive_dose2)}</span>}
              classes='w-1/3 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Utlization of Dose 3'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(active_dose3 + inactive_dose3)}</span>}
              classes='w-1/3 inline-block'
            />
          </div>

          <p className='text-gray-700 text-base font-semibold mt-12 mb-3 leading-none'>COVID Vaccination for dependents</p>
          <div className='flex flex-row justify-between'>
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Utlization of Dose 1'
              metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(active_dependent_dose1 + inactive_dependent_dose1)}</span>}
              classes='w-1/3 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Utlization of Dose 2'
              metricValue={
                <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(active_dependent_dose2 + inactive_dependent_dose2)}</span>
              }
              classes='w-1/3 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Utlization of Dose 3'
              metricValue={
                <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(active_dependent_dose3 + inactive_dependent_dose3)}</span>
              }
              classes='w-1/3 inline-block'
            />
          </div>
      { !loading ?
        <> 
        <UtilizationSankyChart sankeyData={sankyChartData} classes='px-10 py-20' height={450} />
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={unique_users} activeCustomerCount={active_customers_count}/>
      
      <div className='text-gray-700 text-base font-semibold mt-12 mb-3 leading-none'>Utilization based on</div>
      <LodingSquareTabbar loading={loading} loaderHeight={25} list={['Age', 'Gender']} handler={sqaureTabHandler} />
      <div
        className={'mt-3 rounded-md ' + (loading ? '' : 'bg-white ') + (bardata && bardata.length === 0 ? 'pt-6 ' : '')}
      >
        {bardata && bardata.length === 0 && (
          <UserAlert
            para={`${xAxesLabel} data is not available`}
            paraClasses=' font-semibold text-gray-600'
            imgClasses=' h-5 w-5'
            classes=' p-4 ml-6 mr-4'
          />
        )}
        <Bargraph
          loading={loading}
          loaderHeight={300}
          id='utilizationbargraph'
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='300px'
          type='bar'
          ticks={{
            min: 0,
            max: 120,
            stepSize: 20,
          }}
          dataPoints='percentage'
          barTag='percentage'
          xAxesLabel={xAxesLabel}
          yAxesLabel='Percentage of employees'
        />
      </div>

      <div className='flex flex-row mt-12'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold leading-none text-gray-700 mb-1'>Ratings and Reviews</div>
          <div className='text-sm mb-3 text-gray-600'>These ratings are captured after completing the vaccination.</div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='flex flex-col w-2/4'>
          <div className='text-base font-semibold text-gray-700 leading-none mb-1'>Top Comments</div>
          <div className='text-sm mb-3 text-gray-600'>These reviews are captured after completing the vaccination.</div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData || []} classes='h-full' />
        </div>
      </div>
      { selectedContractObj.text.includes('Current') &&
        <>
          <p className='text-gray-700 text-base font-semibold mt-12 mb-0 leading-none'>Future appointments:</p>
          <p className='text-gray-700 text-base font-semibold mt-4 mb-3 leading-none'>COVID Vaccination for employees</p>
          <div className='flex flex-row justify-between'>
            <MetricCard
              loaderHeight={120}
              loading={loading}
              titleClasses='block'
              svgsrc={healthCheckMale}
              title='Employees future appointments'
              metricValue={
                <span className='font-semibold text-3xl text-gray-700'>{commaingNumber(total_vaccination)}</span>
              }
              classes='w-1/4 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Dose 1 appointments'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(dose_1)}</span>}
              classes='w-1/4 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Dose 2 appointments'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(dose_2)}</span>}
              classes='w-1/4 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Dose 3 appointments'
              metricValue={<span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(dose_3)}</span>}
              classes='w-1/4 inline-block'
            />
          </div>

          <p className='text-gray-700 text-base font-semibold mt-12 mb-3 leading-none'>COVID Vaccination for dependents</p>
          <div className='flex flex-row justify-between'>
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={selfspouse}
              titleClasses='block'
              title='Dependent future appointments'
              metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(total_dependent)}</span>}
              classes='w-1/4 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Dose 1 appointments'
              metricValue={<span className='font-semibold text-3xl text-gray-700'>{commaingNumber(dependent_dose_1)}</span>}
              classes='w-1/4 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Dose 2 appointments'
              metricValue={
                <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(dependent_dose_2)}</span>
              }
              classes='w-1/4 inline-block mr-5'
            />
            <MetricCard
              loaderHeight={120}
              loading={loading}
              svgsrc={sirange}
              titleClasses='block'
              title='Dose 3 appointments'
              metricValue={
                <span className=' font-semibold  text-3xl text-gray-700'>{commaingNumber(dependent_dose_3)}</span>
              }
              classes='w-1/4 inline-block'
            />
          </div>
        </>
      }
    </div>
  );
};

export default Vaccination;